import { AfterViewInit, Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import { EventService } from "../services/event.service";
import { HttpErrorResponse } from "@angular/common/http";

interface TestTrackingData {
  last_updated_at: Date;
  total: number;
  failing: number;
  passing: number;
}

export interface TrackingData {
  bms_ipqc: TestTrackingData;
  epack_eol: TestTrackingData;
  pdi: TestTrackingData;
  pdi_lite: TestTrackingData;
}

@Component({
  selector: "app-epack-lifecycle-tracking",
  templateUrl: "./epack-lifecycle-tracking.component.html",
  styleUrls: ["./epack-lifecycle-tracking.component.css"],
})
export class EpackLifecycleTrackingComponent implements OnInit, AfterViewInit {
  constructor(private eventService: EventService) {}

  packId: string = null;
  epackDataStatus: "fetched" | "fetching" | "not-fetched" = "not-fetched";
  isValidPackId: boolean = false;
  trackingData: TrackingData = null;
  batteryType: "piccolo" | "tg" = null;

  ngOnInit(): void {
    // this.getEpackLifecycleTrackingData(String(this.packId));
  }

  ngAfterViewInit(): void {}

  getEpackLifecycleTrackingData(packId: string) {
    if (this.packId) {
      this.epackDataStatus = "fetching";
      this.trackingData = null;
      this.eventService.getEpackLifecycleTrackingData(packId).subscribe({
        next: (res) => {
          this.epackDataStatus = "fetched";
          const { body: responseBody, ok } = res;

          if (!ok) {
            this.triggerErrorSwal(
              "Error getting epack lifecycle tracking data"
            );
            this.resetForm();
            return;
          }

          if (!responseBody.success) {
            this.triggerErrorSwal(responseBody.message);
            this.resetForm();
            return;
          }

          this.batteryType = responseBody.battery_type;
          this.trackingData = { ...responseBody.data };
        },
        error: (error: Error) => {
          this.epackDataStatus = "fetched";
          if (error instanceof HttpErrorResponse) {
            const { message, status, statusText } = error;
            console.log({ message, status, statusText });
          }
          // this.resetForm();
        },
      });
    }
  }

  triggerErrorSwal(message: string) {
    Swal.fire({
      icon: "error",
      title: "Error",
      html: `<p>${message}</p>`,
    });
  }

  resetForm() {
    this.packId = null;
    this.trackingData = null;
    this.epackDataStatus = "not-fetched";
  }

  onTrackPack() {
    const packId = this.packId;

    if (!packId) {
      this.triggerErrorSwal("Pack Id is required");
      return;
    }

    this.getEpackLifecycleTrackingData(packId);
  }
}
